import React, { useState, useEffect } from "react";
import { makeCdnUrl } from "motion-master-client";
import Icon from "./icons";

const DownloadDeviceDescriptions = ({ brandId, version }) => {
  const [gsdmlFiles, setGsdmlFiles] = useState([]);
  const [edsFiles, setEdsFiles] = useState([]);
  const [esiFile, setEsiFile] = useState(null);

  useEffect(() => {
    if (!brandId || !version) return;

    const sanitizedVersion = encodeURIComponent(version.replace(/^v/, ""));

    const checkGsdmlFiles = async () => {
      const candidates = [
        { key: "actilink_s", type: "actilink-s" },
      ];

      const found = [];

      for (const { key, type } of candidates) {
        const file = `${sanitizedVersion}.${type}.gsdml.xml`;
        const url = makeCdnUrl(`/brands/${brandId}/device-descriptions/${file}`);
        try {
          const res = await fetch(url, { method: "HEAD" });
          if (res.ok) found.push({ key, file, url });
        } catch {}
      }
      setGsdmlFiles(found);
    };

    const checkEdsFiles = async () => {
      const candidates = [
        { key: "actilink_s", type: "actilink-s" },
      ];

      const found = [];

      for (const { key, type } of candidates) {
        const file = `${sanitizedVersion}.${type}.eds`;
        const url = makeCdnUrl(`/brands/${brandId}/device-descriptions/${file}`);
        try {
          const res = await fetch(url, { method: "HEAD" });
          if (res.ok) {
            found.push({ key, file, url });
          }
        } catch {}
      }
      setEdsFiles(found);
    };

    checkGsdmlFiles();
    checkEdsFiles();

    const esiFileName = `${sanitizedVersion}.esi.xml`;
    const esiUrl = makeCdnUrl(`/brands/${brandId}/device-descriptions/${esiFileName}`);
    setEsiFile({ key: "esi", file: esiFileName, url: esiUrl });
  }, [brandId, version]);

  const gsdmlLabels = {
    actilink_s: "ACTILINK-S",
  };

  const edsLabels = {
    actilink_s: "ACTILINK-S",
  };

  return (
    <div className="list-group">
      {/* EtherCAT */}
      {esiFile && (
        <>
          <div className="list-group-item text-bg-body fw-semibold">
            EtherCAT
          </div>
          <a
            href={esiFile.url}
            download={esiFile.file}
            rel="noreferrer"
            className="list-group-item list-group-item-action d-flex align-items-center"
          >
            <span className="me-2">{Icon.download}</span>
            ESI (.xml)
          </a>
        </>
      )}

      {/* Ethernet/IP */}
      {edsFiles?.length > 0 && (
        <>
          <div className="list-group-item text-bg-body fw-semibold">
            Ethernet/IP
          </div>

          {edsFiles.map(({ key, file, url }) => (
            <a
              key={file}
              href={url}
              download={file}
              rel="noreferrer"
              className="list-group-item list-group-item-action d-flex align-items-center"
            >
              <span className="me-2">{Icon.download}</span>
              EDS (.eds) for {edsLabels[key]}
            </a>
          ))}
        </>
      )}

      {/* PROFINET */}
      {gsdmlFiles.length > 0 && (
        <>
          <div className="list-group-item text-bg-body fw-semibold">
            PROFINET
          </div>
          {gsdmlFiles.map(({ key, file, url }) => (
            <a
              key={file}
              href={url}
              download={file}
              rel="noreferrer"
              className="list-group-item list-group-item-action d-flex align-items-center"
            >
              <span className="me-2">{Icon.download}</span>
              GSDML (.xml) for {gsdmlLabels[key]}
            </a>
          ))}
        </>
      )}
    </div>
  );
};

export default DownloadDeviceDescriptions;
